export default __webpack_public_path__ + "static/media/f8e2473898f736432ebd707b03f407f6.svg";